// 用途
import rlBaseData from "./rlBaseData";
import mxcad from "mxcad";
const { McGePoint3d, McCmColor, McDbPolyline } = mxcad;
import { rlTextData } from "@/rlMxModules/rlDataClass/index";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import store from "@/store/index";

class rlUseData extends rlBaseData {
  constructor() {
    super();
    this.mcDbPolyline = new McDbPolyline(); // 关联的cad直线类
    this.mcDbId = null; // 关联的cad直线类图形id
    this.classTypeName = "rlUse"; // 用途
    this.useFunction = null; // 用途功能
    this.m_SlabData = null; //用途所在的板
    this.useFunctionName = null; // 用途功能名称/房间名称
    this.m_slabId = null; // 板id
    // this.Color = "#FF0000"; // 构件颜色
    this.m_groupName = "rlUseGroup"; // 组名
    this.points = []; //顶点数据
    this.m_TextObj = null;
    this.nonStructural = true; //非结构构件标识
    this.allEntGuids = []; // 所有关联实体guids
    this.m_useType = "UseName"; // UseName:用途功能 RoomName:房间名称
  }

  // 克隆数据
  myClone() {
    const newObj = new rlUseData();
    newObj.points = this.points.slice();
    newObj.StdFlrGuid = this.StdFlrGuid;
    newObj.useFunction = this.useFunction;
    newObj.m_useType = this.m_useType;
    newObj.useFunctionName = this.useFunctionName;
    for (let i = 0; i < this.points.length; i++) {
      newObj.mcDbPolyline.addVertexAt(
        new McGePoint3d(this.points[i].x, this.points[i].y, this.points[i].z)
      );
    }
    newObj.mcDbPolyline.trueColor = new McCmColor(255, 0, 0);
    // newObj.Color = this.Color;
    newObj.mcDbPolyline.setxDataString("Guid", newObj.Guid);
    newObj.mcDbPolyline.setxDataString("classTypeName", newObj.classTypeName);
    newObj.mcDbPolyline.visible = store.state.displayData.useDisplay;
    return newObj;
  }

  initData(obj) {
    // 合理性校验
    if (!obj.points) {
      this.erase();
      return;
    }
    super.initData(obj);
    this.No_ = obj.No_;
    this.m_slabId = obj.m_slabId;
    this.useFunction = obj.useFunction;
    this.useFunctionName = obj.useFunctionName;
    this.setUseFunctionName();
    this.points = obj.points.slice();
    this.m_useType = obj.m_useType;
    this.allEntGuids = obj.allEntGuids;
    // 白色
    this.mcDbPolyline.trueColor = new McCmColor(255, 255, 255);

    let numVerts = this.mcDbPolyline.numVerts() - 1;
    for (let i = numVerts; i >= 0; i--) {
      this.mcDbPolyline.removeVertexAt(i);
    }

    for (let i = 0; i < this.points.length; i++) {
      this.mcDbPolyline.addVertexAt(
        new McGePoint3d(this.points[i].x, this.points[i].y, this.points[i].z)
      );
    }
    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);
    // this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbGrid)
    if (this.m_useType === "UseName" && obj.m_SlabData) {
      this.m_SlabData = obj.m_SlabData;
      this.m_SlabData.m_useId = this.Guid;
    }
    //更新构件房间号
    this.updateEntRoomName(false);
    //绘制文字
    if (this.m_TextObj) {
      this.m_TextObj?.erase();
      this.drawUseText();
    }
  }

  //更新构件房间号
  updateEntRoomName(isUpdate = true) {
    // 如果有关联的实体，则将房间名加入实体命名中
    if (this.allEntGuids) {
      this.setEntUseFunctionNames(
        this.allEntGuids.partitionWallGuids,
        "rlPartitionWallSeg",
        "隔墙",
        isUpdate
      );
      this.setEntUseFunctionNames(
        this.allEntGuids.wallGuids,
        "rlWallSeg",
        "墙",
        isUpdate
      );
      this.setEntUseFunctionNames(
        this.allEntGuids.slabGuids,
        "rlSlab",
        "板",
        isUpdate
      );
      this.setEntUseFunctionNames(
        this.allEntGuids.beamGuids,
        "rlBeamSeg",
        "梁",
        isUpdate
      );
      this.setEntUseFunctionNames(
        this.allEntGuids.columnGuids,
        "rlColSeg",
        "柱",
        isUpdate
      );
    }
  }

  setEntUseFunctionNames(EntGuids, classTypeName, name, isUpdate = true) {
    if (EntGuids) {
      EntGuids.forEach((guid) => {
        let selectObj = getEntityData({
          Guid: guid,
          classTypeName: classTypeName,
        });
        if (selectObj) {
          let roomName = this.useFunctionName + "-" + name + selectObj.No_;
          //如果已经存在，则跳过
          if (
            selectObj.useFunctionNames.find((item) => item.roomName == roomName)
          ) {
            return;
          }
          if (isUpdate) {
            selectObj.saveEditRevokeData();
          }
          selectObj.useFunctionNames.push({
            roomName: roomName,
            Guid: this.Guid,
          });
          if (isUpdate) {
            selectObj.updateThisObj(selectObj, false);
          }
        }
      });
    }
  }
  setUseFunctionName() {
    switch (this.useFunction) {
      case 61:
        this.useFunctionName = "厨房";
        break;
      case 62:
        this.useFunctionName = "餐厅";
        break;
      case 63:
        this.useFunctionName = "办公室";
        break;
      case 64:
        this.useFunctionName = "健身房";
        break;
      case 65:
        this.useFunctionName = "卫生间";
        break;
      case 66:
        this.useFunctionName = "其他";
        break;
      default:
        this.useFunctionName = this.useFunctionName;
        break;
    }
  }

  draw() {
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().erase();
      this.mcDbPolyline = new McDbPolyline();
    }
    let numVerts = this.mcDbPolyline.numVerts() - 1;
    for (let i = numVerts; i >= 0; i--) {
      this.mcDbPolyline.removeVertexAt(i);
    }

    for (let i = 0; i < this.points.length; i++) {
      this.mcDbPolyline.addVertexAt(
        new McGePoint3d(this.points[i].x, this.points[i].y, this.points[i].z)
      );
    }
    this.mcDbPolyline.isClosed = true;
    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);
    this.mcDbPolyline.visible = store.state.displayData.useDisplay;

    this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
    this.drawUseText();
  }

  // saveEditRevokeData() {
  //   //解除网格与节点的关联
  //   this.m_stJoint.m_gridIds = this.m_stJoint.m_gridIds.filter(
  //     (item) => item != this.Guid
  //   );
  //   this.m_edJoint.m_gridIds = this.m_edJoint.m_gridIds.filter(
  //     (item) => item != this.Guid
  //   );
  //   //解除网格与轴线的关联
  //   this.m_Axis.m_gridIds = this.m_Axis.m_gridIds.filter(
  //     (item) => item != this.Guid
  //   );
  //   super.saveEditRevokeData();
  // }

  // 数据修改更新
  updateThisObj(obj) {
    this.points = obj.points.slice();
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().erase();
      this.mcDbPolyline = new McDbPolyline();
    }
    for (let i = 0; i < this.points.length; i++) {
      this.mcDbPolyline.addVertexAt(
        new McGePoint3d(this.points[i].x, this.points[i].y, this.points[i].z)
      );
    }
    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);
    this.mcDbPolyline.isClosed = true;
    this.mcDbPolyline.visible = store.state.displayData.useDisplay;
    this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
    this.setUseFunctionName();
    this.drawUseText();
    super.updateThisObj(obj);
  }

  calculateCentroid(points) {
    if (points.length === 0) {
      return null;
    }

    // 计算多边形的边界框
    let minX = Infinity,
      maxX = -Infinity;
    let minY = Infinity,
      maxY = -Infinity;
    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算边界框的尺寸
    const width = maxX - minX;
    const height = maxY - minY;
    const minSize = Math.min(width, height);

    // 设置最小边距，为边界框最小尺寸的10%
    const minMargin = minSize * 0.1;

    // 使用多边形面积加权的方法计算重心
    let area = 0;
    let centroidX = 0;
    let centroidY = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;

    if (Math.abs(area) < 1e-8) {
      // 如果面积接近0，返回边界框中心点
      return new McGePoint3d((minX + maxX) / 2, (minY + maxY) / 2, 0);
    }

    const factor = 1 / (6 * area);
    centroidX *= factor;
    centroidY *= factor;

    // 检查点是否在多边形内部且距离边缘足够远
    if (
      this.isPointInPolygonWithMargin(centroidX, centroidY, points, minMargin)
    ) {
      return new McGePoint3d(centroidX, centroidY, 0);
    }

    // 如果重心点不满足条件，在多边形内部寻找合适的点
    return this.findSafeInteriorPoint(points, minMargin);
  }

  // 判断点是否在多边形内部且距离边缘有足够距离
  isPointInPolygonWithMargin(x, y, points, margin) {
    if (!this.isPointInPolygon(x, y, points)) return false;

    // 检查到所有边的距离
    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      // 计算点到线段的距离
      const distance = this.pointToLineDistance(x, y, p1, p2);
      if (distance < margin) return false;
    }

    return true;
  }

  // 计算点到线段的距离
  pointToLineDistance(x, y, p1, p2) {
    const A = x - p1.x;
    const B = y - p1.y;
    const C = p2.x - p1.x;
    const D = p2.y - p1.y;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;

    // 参数方程的参数
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;

    let xx, yy;

    if (param < 0) {
      xx = p1.x;
      yy = p1.y;
    } else if (param > 1) {
      xx = p2.x;
      yy = p2.y;
    } else {
      xx = p1.x + param * C;
      yy = p1.y + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;

    return Math.sqrt(dx * dx + dy * dy);
  }

  // 在多边形内部寻找安全的点
  findSafeInteriorPoint(points, margin) {
    // 计算边界框
    let minX = Infinity,
      maxX = -Infinity;
    let minY = Infinity,
      maxY = -Infinity;

    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算中心点
    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;

    // 从中心开始，螺旋式向外搜索
    const gridSize = margin / 2;
    let radius = 0;
    const maxRadius = Math.max(maxX - minX, maxY - minY);

    while (radius <= maxRadius) {
      // 在当前半径的圆上采样点
      for (let angle = 0; angle < Math.PI * 2; angle += Math.PI / 8) {
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          return new McGePoint3d(x, y, 0);
        }
      }

      radius += gridSize;
    }

    // 如果螺旋搜索失败，使用网格搜索作为备选方案
    const rows = 10;
    const cols = 10;
    const stepX = (maxX - minX - 2 * margin) / cols;
    const stepY = (maxY - minY - 2 * margin) / rows;

    let bestPoint = null;
    let minDistanceToCenter = Infinity;

    for (let i = 0; i <= rows; i++) {
      for (let j = 0; j <= cols; j++) {
        const x = minX + margin + j * stepX;
        const y = minY + margin + i * stepY;

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          // 计算到中心点的距离
          const distToCenter = Math.sqrt(
            Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
          );

          if (distToCenter < minDistanceToCenter) {
            minDistanceToCenter = distToCenter;
            bestPoint = { x, y };
          }
        }
      }
    }

    if (bestPoint) {
      return new McGePoint3d(bestPoint.x, bestPoint.y, 0);
    }

    // 最后的备选方案：使用重心
    let centroidX = 0;
    let centroidY = 0;
    let area = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;
    if (Math.abs(area) > 1e-8) {
      const factor = 1 / (6 * area);
      centroidX *= factor;
      centroidY *= factor;

      // 如果重心在多边形内且满足边距要求，直接使用重心
      if (
        this.isPointInPolygonWithMargin(centroidX, centroidY, points, margin)
      ) {
        return new McGePoint3d(centroidX, centroidY, 0);
      }
    }

    // 最终备选：三角形重心
    return new McGePoint3d(
      (points[0].x + points[1].x + points[2].x) / 3,
      (points[0].y + points[1].y + points[2].y) / 3,
      0
    );
  }

  drawUseText() {
    if (this.m_TextObj) {
      this.m_TextObj.erase();
    }
    this.m_TextObj = new rlTextData();
    let location = this.calculateCentroid(this.points);
    if (!location) return;
    this.m_TextObj.position = location;
    this.m_TextObj.Text = this.useFunctionName;
    this.m_TextObj.textType = "用途文字";
    this.m_TextObj.McDbText.setxDataString("Guid", this.Guid);
    this.m_TextObj.McDbText.setxDataString("classTypeName", this.classTypeName);
    this.m_TextObj.draw(store.state.displayData.useDisplay);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
    let textObj = this.m_TextObj.mcDbId.getMcDbEntity();
    textObj.alignmentPoint = textObj.position = location;
  }

  //移动网格：删除原网格，重新布置网格
  async transformBy(vecMove) {
    return;
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();
    data["No_"] = this.No_;
    data["UseFunction"] = this.useFunction;
    data["SlabGuid"] = this.m_slabId;
    data["UseType"] = this.m_useType;
    data["PartitionWallGuids"] = JSON.stringify(this.allEntGuids);
    data["UseFunctionName"] = this.useFunctionName;
    let points = {};
    for (let i = 0; i < this.points.length; i++) {
      points[i] = {
        x: this.points[i].x,
        y: this.points[i].y,
        z: this.points[i].z,
      };
    }
    data["Points"] = JSON.stringify(points);
    return data;
  }

  //删除房间命名
  deleteRoomName(EntGuids, classTypeName) {
    for (let i = 0; i < EntGuids.length; i++) {
      let selectObj = getEntityData({
        Guid: EntGuids[i],
        classTypeName: classTypeName,
      });
      if (!selectObj) continue;
      selectObj.useFunctionNames = selectObj.useFunctionNames.filter(
        (item) => item.Guid !== this.Guid
      );
    }
  }

  erase() {
    this.m_SlabData ? (this.m_SlabData.m_useId = null) : "";
    this.mcDbPolyline?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    this.m_TextObj?.erase();
    //删除房间命名
    if (this.allEntGuids) {
      if (this.allEntGuids.partitionWallGuids) {
        this.deleteRoomName(
          this.allEntGuids.partitionWallGuids,
          "rlPartitionWallSeg"
        );
      }
      if (this.allEntGuids.wallGuids) {
        this.deleteRoomName(this.allEntGuids.wallGuids, "rlWallSeg");
      }
      if (this.allEntGuids.slabGuids) {
        this.deleteRoomName(this.allEntGuids.slabGuids, "rlSlab");
      }
      if (this.allEntGuids.beamGuids) {
        this.deleteRoomName(this.allEntGuids.beamGuids, "rlBeamSeg");
      }
      if (this.allEntGuids.columnGuids) {
        this.deleteRoomName(this.allEntGuids.columnGuids, "rlColSeg");
      }
    }
    super.erase();
  }
  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    // return {};
    const data = super.getDrawData();
    data["useFunction"] = this.useFunction;
    data["m_slabId"] = this.m_slabId;

    let points = "";
    for (let i = 0; i < this.points.length; i++) {
      points += `${this.points[i].x},${this.points[i].y},${this.points[i].z},`;
    }
    data["points"] = points;
    data["useFunctionName"] = this.useFunctionName;
    data["useType"] = this.m_useType;
    data["allEntGuids"] = JSON.stringify(this.allEntGuids);

    return data;
  }

  // 用于撤销回退
  reDraw(obj) {
    // return;
    super.reDraw(obj);
    this.useFunction = obj.useFunction;
    this.useFunctionName = obj.useFunctionName;

    this.points = [];
    let points = obj.points.split(",");
    for (let i = 0; i < points.length - 2; i += 3) {
      this.points.push(
        new McGePoint3d(points[i], points[i + 1], points[i + 2])
      );
    }

    this.m_slabId = obj.m_slabId;
    this.m_useType = obj.useType;
    this.allEntGuids = obj.allEntGuids ? JSON.parse(obj.allEntGuids) : {};
  }

  // 判断点是否在多边形内部
  isPointInPolygon(x, y, points) {
    let inside = false;

    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      const xi = points[i].x,
        yi = points[i].y;
      const xj = points[j].x,
        yj = points[j].y;

      // 射线法判断点是否在多边形内部
      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

      if (intersect) inside = !inside;
    }

    return inside;
  }
}

export { rlUseData };
